import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ThemeService } from '../../../../../service/services/misc/theme/theme.service';
import { Subscription } from 'rxjs';
import { ThemeSubjectModel } from '../../../../../service/services/misc/theme/theme-subject.model';
import { Const } from '../../../Const';
import { Utils } from '../../../Utils';

@Component({
    selector: 'app-yaml',
    templateUrl: './yaml.component.html',
    styleUrls: ['./yaml.component.scss'],
    standalone: false
})
export class YamlComponent extends FieldType<FieldTypeConfig> implements OnInit, OnDestroy {
    theme: string;
    themeSubscription: Subscription;

    constructor(private themeService: ThemeService) {
        super();
    }

    ngOnInit() {
        this.themeSubscription = this.themeService.themeSubject.asObservable().subscribe((theme: ThemeSubjectModel) => {
            this.theme = Const.YAML_THEMES[theme.selectedTheme];
        });
        if (this.field.model) {
            let yaml = Utils.convertToYamlFile(this.field.model);
            this.field.formControl.setValue(yaml);
        }
    }

    ngOnDestroy() {
        if (this.themeSubscription) {
            this.themeSubscription.unsubscribe();
        }
    }
}
